export const CHARGEDAYTOTAL = "CHARGEDAYTOTAL"
export const DAYCHARGETREND = "DAYCHARGETREND"
export const DAYRECORDTOTAL = "DAYRECORDTOTAL"
export const DAYMONTHLYCARSTAT = "DAYMONTHLYCARSTAT"
export const DAYTEMPORARYCARSTAT = "DAYTEMPORARYCARSTAT"
export const DAYSTOREDCARSTAT = "DAYSTOREDCARSTAT"

export const CHARGEMONTHTOTAL = "CHARGEMONTHTOTAL"
export const MONTHCHARGETREND = "MONTHCHARGETREND"
export const MONTHRECORDTOTAL = "MONTHRECORDTOTAL"
export const MONTHMONTHLYCARSTAT = "MONTHMONTHLYCARSTAT"
export const MONTHTEMPORARYCARSTAT = "MONTHTEMPORARYCARSTAT"
export const MONTHSTOREDCARSTAT = "MONTHSTOREDCARSTAT"

export const RECHARGETREND = "RECHARGETREND"





// WEBPACK FOOTER //
// ./src/store/app/bill/types.js